import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  addProductUnitType,
  addProductUnitTypeSuccess,
  deleteProductUnitType,
  deleteProductUnitTypeSuccess,
  getProductUnitTypeList,
  updateProductUnitType,
  updateProductUnitTypeSuccess,
} from "../../../../store/product/action";

import {
  addMasterTimeFrame,
  addMasterTimeFrameSuccess,
  addRenewalFrequencies,
  addRenewalFrequenciesSuccess,
  addUnitFrequencies,
  addUnitFrequenciesSuccess,
  deleteMasterTimeFrame,
  deleteMasterTimeFrameSuccess,
  deleteRenewalFrequencies,
  deleteRenewalFrequenciesSuccess,
  deleteUnitFrequencies,
  deleteUnitFrequenciesSuccess,
  getMasterTimeFrameList,
  getRenewalFrequenciesList,
  getUnitFrequenciesList,
  updateMasterTimeFrame,
  updateMasterTimeFrameSuccess,
  updateRenewalFrequencies,
  updateRenewalFrequenciesSuccess,
  updateUnitFrequencies,
  updateUnitFrequenciesSuccess,
} from "../../../../store/generalSettings/action";
import StatusViewEditComponent from "../../company/components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

export default function SuperGeneralSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [config, setConfig] = useState(null);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    IntervalValueMathSign: "+",
    IntervalValue: 7,
    MasterTimeFrameInterval_Id: "1",
  });

  const { productUnitTypeListAPI } = useSelector((state) => ({
    productUnitTypeListAPI:
      state.ProductCrmIT.productUnitTypeList?.unittype_list,
  }));
  const {
    renewalFrequenciesListAPI,
    unitFrequenciesListAPI,
    masterTimeFrameListAPI,
  } = useSelector((state) => ({
    renewalFrequenciesListAPI:
      state.GeneralSettings.renewalFrequenciesList?.renewalfrequency_list,
    unitFrequenciesListAPI:
      state.GeneralSettings.unitFrequenciesList?.unitfrequency_list,
    masterTimeFrameListAPI:
      state.GeneralSettings.masterTimeFrameList?.mastertimeframeinterval_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      dispatch(addMasterTimeFrame([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];

    if (activeTab === "1") {
      data = masterTimeFrameListAPI?.sort((a, b) => b.Id - a.Id);
      setConfig({
        name: "generalSettingsMasterFrequency",
      });
    }
    setStatusList(data);
  }, [activeTab, masterTimeFrameListAPI]);

  useEffect(() => {
    dispatch(getMasterTimeFrameList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      dispatch(deleteMasterTimeFrame([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      IntervalValue: updateItemStatus?.IntervalValue,
      IntervalValueMathSign: updateItemStatus?.IntervalValueMathSign,
      MasterTimeFrameInterval_Id: updateItemStatus?.MasterTimeFrameInterval_Id,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        dispatch(updateMasterTimeFrame([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  //Effects
  const { updateMasterTimeFrameSuccessAPI, deleteMasterTimeFrameSuccessAPI } =
    useSelector((state) => ({
      addMasterTimeFrameSuccessAPI:
        state.GeneralSettings.addMasterTimeFrameSuccess,
      updateMasterTimeFrameSuccessAPI:
        state.GeneralSettings.updateMasterTimeFrameSuccess,
      deleteMasterTimeFrameSuccessAPI:
        state.GeneralSettings.deleteMasterTimeFrameSuccess,
    }));

  // Effect update master time frame success
  useEffect(() => {
    if (isEmpty(updateMasterTimeFrameSuccessAPI)) return;
    if (updateMasterTimeFrameSuccessAPI?.status === 200) {
      toast.success(updateMasterTimeFrameSuccessAPI?.message);
      dispatch(getMasterTimeFrameList());
    } else {
      toast.error(updateMasterTimeFrameSuccessAPI?.message);
    }
    dispatch(updateMasterTimeFrameSuccess([]));
  }, [updateMasterTimeFrameSuccessAPI]);

  // Effect delete master time frame success
  useEffect(() => {
    if (isEmpty(deleteMasterTimeFrameSuccessAPI)) return;
    if (deleteMasterTimeFrameSuccessAPI?.status === 200) {
      toast.success(deleteMasterTimeFrameSuccessAPI?.message);
      dispatch(getMasterTimeFrameList());
      setDeleteModal(false);
    } else {
      toast.error(deleteMasterTimeFrameSuccessAPI?.message);
    }
    dispatch(deleteMasterTimeFrameSuccess([]));
  }, [deleteMasterTimeFrameSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="General"
        description="Master time interval definitions used across all companies."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          config={config}
        />
      </SettingsPanel>
    </>
  );
}
